export const state = {
  trucks: [],
  systemTruck: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucks/state.js